import { ArthrosamidAnalytics } from "@/features/analytics/features/arthrosamid/ArthrosamidAnalytics";
import { createFileRoute } from "@tanstack/react-router";
import { managerGetArthrosamidDiariesQueryOptions } from "../../../features/analytics/features/arthrosamid/api/managerGetArthrosamidDiaries";

const ArthrosamidAnalyticsPage = () => {
	const diaries = Route.useLoaderData();
	return <ArthrosamidAnalytics diaries={diaries} />;
};

export const Route = createFileRoute("/_app/analytics/arthrosamid")({
	component: ArthrosamidAnalyticsPage,
	loader: async ({ context }) => {
		const diaries = context.queryClient.ensureQueryData(
			managerGetArthrosamidDiariesQueryOptions(),
		);
		return diaries;
	},
});
